"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.levelOfStudyList = void 0;
exports.levelOfStudyList = [
    {
        value: "01",
        label: "Primary School",
    },
    {
        value: "02",
        label: "Secondary School",
    },
    {
        value: "10",
        label: "PTC/TCST/DVS/AVS",
    },
    {
        value: "11",
        label: "CEGEP - Pre-university",
    },
    {
        value: "12",
        label: "CEGEP - Technical",
    },
    {
        value: "13",
        label: "College - Certificate",
    },
    {
        value: "14",
        label: "College - Diploma",
    },
    {
        value: "15",
        label: "College - Applied degree",
    },
    {
        value: "04",
        label: "University - Bachelor's Deg.",
    },
    {
        value: "05",
        label: "University - Master's Deg.",
    },
    {
        value: "06",
        label: "University - Doctorate",
    },
    {
        value: "07",
        label: "University - Other Studies",
    },
    {
        value: "16",
        label: "ESL/FSL",
    },
    {
        value: "17",
        label: "ESL/FSL and College",
    },
    {
        value: "18",
        label: "ESL/FSL and University",
    },
    {
        value: "08",
        label: "Other Studies",
    },
    {
        value: "19",
        label: "Not Applicable",
    },
];
